import { render, staticRenderFns } from "./MyTariff.vue?vue&type=template&id=3085dfef&scoped=true&"
import script from "./MyTariff.vue?vue&type=script&lang=js&"
export * from "./MyTariff.vue?vue&type=script&lang=js&"
import style0 from "./MyTariff.vue?vue&type=style&index=0&id=3085dfef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3085dfef",
  null
  
)

export default component.exports